import { Component } from '@angular/core';

@Component({
  selector: 'ava-expansion-panel-content',
  standalone: true,
  template: ` <ng-content /> `,
})
export class ExpansionPanelContentComponent {}
